import { useCallback, useState } from 'react'
import { v4 as uuid } from 'uuid'
import type { ToastProperties } from '#components/Toast'
import { toaster } from './toaster'

export type ToastId = string & { __toastIdBrand: never }
type Toast = ToastProperties & { id: ToastId; visibleUntil?: number }

export const useCreateToastContext = () => {
  const [toasts, setToasts] = useState<Toast[]>([])

  const addToast = useCallback((toast: ToastProperties) => {
    const visibleInMs = toast.visibleInMs ?? 3000
    const id = uuid() as ToastId
    setToasts((toasts) => [
      ...toasts,
      {
        ...toast,
        id,
        visibleInMs,
        visibleUntil: visibleInMs > 0 ? visibleInMs + Date.now() : undefined,
      },
    ])
    return id
  }, [])

  const removeToast = useCallback((id: ToastId) => {
    setToasts((toasts) => toasts.filter((x) => x.id !== id))
  }, [])

  toaster.add = addToast
  toaster.remove = removeToast

  return {
    toasts,
    add: addToast,
    remove: removeToast,
  }
}
